import i18n from "src/app/shared/localization/i18n";
export const MIN_PASSWORD_LENGTH: number = 6;
export const MIN_LOGIN_LENGTH: number = 6;
export const MAX_LOGIN_LENGTH: number = 40;
export const MAX_PASSWORD_LENGTH: number = 40;
export const MASKED_PASSWORD: string = "----------";

export const OPERATOR_SETTING_PREFIX: string = "Operator_";

export const EMPTY_NAME_TOOLTIP_MESSAGE: string = i18n.t('operators.emptyNameTooltipMessage');
export const EMPTY_LOGIN_TOOLTIP_MESSAGE: string = i18n.t('operators.emptyLoginTooltipMessage');
export const EMPTY_PASSWORD_TOOLTIP_MESSAGE: string = i18n.t('operators.emptyPasswordTooltipMessage');
export const MIN_LENGTH_PASSWORD_MESSAGE: string = i18n.t('operators.minLengthPasswordMessage') + MIN_PASSWORD_LENGTH;
export const MIN_LENGTH_LOGIN_MESSAGE: string = i18n.t('operators.minLengthLoginMessage') + MIN_LOGIN_LENGTH;

export const CHANGE_AVATAR_NULL_ID_ERROR_MESSAGE: string = i18n.t('operators.changeAvatarNullIdErrorMessage');

export const SAVE_OPERATOR_SETTINGS_NULL_ID_MESSAGE: string = i18n.t('operators.saveOperatorSettingsNullIdMessage');

export const SPACE_IN_LOGIN_ERROR_MESSAGE: string = i18n.t('operators.spaceInLoginErrorMessage');